import { ContentBlock, ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import React, { useCallback } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { useCreateUploadImagesMutation } from 'redux/reducers/routine';
import { backendURL } from 'redux/reducers/settings';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

interface IEditorComponent {
  onChangeValue: (value: string) => void;
  editorValue: string;
  containerClassName?: string;
  label: string;
  withoutMinHeight?: boolean;
  placeholder?: string;
  folderName?:string
}

interface HTMLBlock {
  contentBlocks: ContentBlock[];
  entityMap: any;
}

const EditorComponent = (props: IEditorComponent) => {
  const { onChangeValue, editorValue } = props;

  const [editorState, setEditorState] = React.useState(() => EditorState.createEmpty());
  const [rawHtmlContent, setrawHtmlContent] = React.useState('');

  const initEditorData = useCallback((htmlText: string) => {
    if (htmlText?.trim()?.length) {
      const blocksFromHtml = htmlToDraft(htmlText) as HTMLBlock;
      const { contentBlocks, entityMap } = blocksFromHtml;
      const content = ContentState.createFromBlockArray(contentBlocks, entityMap);
      const draftContent = EditorState.createWithContent(content);
      setEditorState(draftContent);
    } else {
      const editorState = EditorState.createEmpty();
      setEditorState(editorState);
      setrawHtmlContent('');
    }
  }, []);

  const onEditorStateChange = (editorState: EditorState) => {
    const rawContentState = convertToRaw(editorState.getCurrentContent());
    let htmlContent = draftToHtml(rawContentState);

    if (!editorState.getCurrentContent().hasText()) {
      htmlContent = '';
    }

    setEditorState(editorState);
    onChangeValue(htmlContent);
    setrawHtmlContent(htmlContent);
  };

  React.useEffect(() => {
    if (editorValue !== rawHtmlContent) {
      initEditorData(editorValue);
    }
  }, [editorValue, rawHtmlContent, initEditorData]);

    const [createUploadImage, { isLoading }] = useCreateUploadImagesMutation();
  

const uploadImageCallback = (file: File): Promise<{ data: { link: string } }> => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('file', file);
    
    if (props?.folderName) {
      formData.append('folder_name', props.folderName);
    }

    createUploadImage(formData)
      .unwrap()
      .then((result: any) => {
        const filePath = result?.data?.path;

        console.log("File Path:", filePath);
        

        if (!filePath) {
          reject(new Error("No image path returned from server"));
          return;
        }

   
        const baseUrl = backendURL; // Replace with your actual API base URL
        const fullImageUrl = filePath.startsWith('http') ? filePath : `${baseUrl}${filePath}`;

        console.log('fullImageUrl',fullImageUrl);
        

        resolve({ data: { link: fullImageUrl } });
      })
      .catch((error: any) => {
        console.error("Image upload failed:", error);
        reject(error);
      });
  });
};

  return (
    <div className={props.containerClassName ?? 'mt-3 col-lg-4 col-md-6'}>
      <label htmlFor="fname-field" className="profile-details-heading">
        {props.label}
      </label>
      <div>
        <Editor
          // defaultContentState={
          //   convertToRaw(ContentState.createFromText(editorValue)) || "some ="
          // }
          editorState={editorState}
          editorStyle={{ minHeight: props.withoutMinHeight ? 160 : 300 }}
          wrapperClassName="demo-wrapper"
          editorClassName={props.withoutMinHeight ? 'demo-editor-small' : 'demo-editor'}
          onEditorStateChange={onEditorStateChange as any}
          placeholder={props.placeholder}
            toolbar={{
            options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link', 'emoji', 'image', 'history'],
            image: {
              uploadCallback: uploadImageCallback,
              alt: { present: true, mandatory: false },
              previewImage: true,
              inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
            },
          }}
        />
      </div>
    </div>
  );
};

export default EditorComponent;
